import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FC, useMemo } from "react";

export type PaymentFilterValue = "all" | "paid" | "unpaid";

type PaymentStatusFilterProps = {
  value: PaymentFilterValue;
  onChange: (value: PaymentFilterValue) => void;
};

const PaymentStatusFilter: FC<PaymentStatusFilterProps> = ({ value, onChange }) => {
  const labelId = useMemo(() => `payment-filter-${Math.random().toString(36).slice(2, 8)}`, []);

  const handleChange = (event: SelectChangeEvent) => {
    const newValue = event.target.value as PaymentFilterValue;
    onChange(newValue);
  };

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id={labelId}>Status de pagamento</InputLabel>
      <Select
        labelId={labelId}
        label="Status de pagamento"
        value={value}
        onChange={handleChange}
      >
        <MenuItem value="all">Todos</MenuItem>
        <MenuItem value="paid">Pagos</MenuItem>
        <MenuItem value="unpaid">Não pagos</MenuItem>
      </Select>
    </FormControl>
  );
};

export default PaymentStatusFilter;
